import React from 'react';

// A to-scale rectangle of a machine's sheet, sized against maxMm (the largest machine dimension in the
// comparison set) so rectangles are comparable — a bigger machine renders bigger. Width is written along
// the bottom edge and height up the left edge (each number on the axis it measures). The bed self-identifies
// its machine type with a centered icon AND color (so it doesn't rely on the column header alone): printing a
// printer (blue), die-cutting scissors (green), combined cogs (purple). Used by the ManufacturingLine cards.
const STAGE_PX = 120;
export const KIND = {
  die_cutting: { color: '#2e7d32', background: 'rgba(46, 125, 50, 0.10)', icon: 'fa-scissors' },
  printing: { color: '#1565c0', background: 'rgba(21, 101, 192, 0.12)', icon: 'fa-print' },
  combined: { color: '#6a1b9a', background: 'rgba(106, 27, 154, 0.12)', icon: 'fa-cogs' }
};

// The faint machine icon (printer / scissors / cogs) centered inside a bed, sized to the bed but kept legible
// (12-28px). Exported so the solution cards draw the same icon the ManufacturingLine cards do.
export const MachineIcon = ({ kind, widthPx, heightPx }) => {
  const style = KIND[kind];
  if (!style || !style.icon) { return null; }
  const size = Math.max(12, Math.min(28, Math.min(widthPx, heightPx) * 0.5));
  return <i className={`fa ${style.icon}`} style={{ fontSize: `${size}px`, color: style.color, opacity: 0.6 }} aria-hidden="true" />;
};

const MachineSheetRectangle = ({ widthMm, heightMm, kind, maxMm }) => {
  const max = parseFloat(maxMm);
  if (!widthMm || !heightMm || !max || max <= 0) { return null; }

  const toDisplay = (valueMm) => (
    window.user_unit == 'in'
      ? `${(parseFloat(valueMm) / 25.4).toFixed(2)}in`
      : `${Math.round(parseFloat(valueMm))}mm`
  );
  const toPx = (valueMm) => Math.max(10, (parseFloat(valueMm) / max) * STAGE_PX);
  const widthPx = toPx(widthMm);
  const heightPx = toPx(heightMm);
  const labelColor = '#777';
  const kindStyle = KIND[kind] || {};

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', marginTop: '8px', marginBottom: '20px' }}>
      <div style={{ fontSize: '11px', color: labelColor, lineHeight: 1, writingMode: 'vertical-rl', transform: 'rotate(180deg)', textAlign: 'center', height: `${heightPx}px`, marginRight: '3px' }}>{toDisplay(heightMm)}</div>
      <div style={{ position: 'relative', width: `${widthPx}px`, height: `${heightPx}px` }}>
        <div style={{
          width: '100%', height: '100%', boxSizing: 'border-box', borderRadius: '2px', overflow: 'hidden',
          border: `2px solid ${kindStyle.color}`, background: kindStyle.background,
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <MachineIcon kind={kind} widthPx={widthPx} heightPx={heightPx} />
        </div>
        <div style={{ position: 'absolute', top: '100%', left: '50%', transform: 'translateX(-50%)', marginTop: '3px', fontSize: '11px', color: labelColor, lineHeight: 1, whiteSpace: 'nowrap' }}>{toDisplay(widthMm)}</div>
      </div>
    </div>
  );
};

export default MachineSheetRectangle;
